import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {FONT_FAMILY_REGULAR,PRIMARY_FONT_COLOR, SMALL_TEXT_PX} from '../../../../styles/fonts/MCFontConstants';

export const RadioComponentSelector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ radioComponentAlignItem }) =>
        radioComponentAlignItem ? radioComponentAlignItem : 'center'};
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '20px'};
    /* max-height: 15px;
    margin: 25px 0px;
    margin-bottom: 20px; */
    &:hover {
        cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
    }
    ${media.mediumDevice`
        padding-right:${({ iPadPaddingRight }) =>
            iPadPaddingRight ? iPadPaddingRight : '20px'};
    `}

    @media only screen and  (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
        /* For ipadPro landscape layouts only */
        padding-right: ${({ iPadPaddingRight, paddingRight }) =>
            iPadPaddingRight ? iPadPaddingRight : paddingRight?paddingRight:'20px'};
    }
`;

export const RadioComponentLabels = styled.label`
    display: flex;
    font-family: ${({ fontFamilyStyle }) =>
        fontFamilyStyle ? fontFamilyStyle :FONT_FAMILY_REGULAR};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : SMALL_TEXT_PX)};
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    align-items: ${({ radioLabelAlignItem }) =>
        radioLabelAlignItem ? radioLabelAlignItem : 'center'};
    padding: ${({ padding }) => (padding ? padding : '')};
    &:hover {
        cursor: pointer;
    }
    ${media.smalDevice`
		max-width: none;
    `}
`;
export const RadioSvg = styled.img`
    margin-right: 10px;
    margin-top: ${({ marginTop }) => marginTop};
`;

export const RadioFormElement = styled.input`
    display: none;
`;
